import { css } from 'emotion';

export default {
    emptyContainer: css`
        height: 30vw;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
    jobName: css`
        margin-top: 12px;
    `,
    jobId: css`
        margin-top: 4px;
    `
};
